const app = angular.module('formApp', ['validation.match', 'ngMaterial', 'ngMessages', 'ngSanitize', "ui.router", "ui.router.state.events", 'ngAnimate'])
    .config(["$mdThemingProvider", function ($mdThemingProvider) {
        const v4pPalette = $mdThemingProvider.extendPalette('indigo', {
            '200': '4d2b88',
            '500': '1b015a',
            '700': 'd32f2f',
            'A200': 'E60064',
            'A400': 'E60064',
            'A700': 'ad003a',
            'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                                // on this palette should be dark or light

            'contrastDarkColors': ['50', '100', //hues which contrast should be 'dark' by default
                '200', '300', '400', 'A100'],
            'contrastLightColors': undefined    // could also specify this if default was 'dark'
        });
        $mdThemingProvider.definePalette('v4pPalette', v4pPalette);
        $mdThemingProvider.theme('default')
            .primaryPalette('v4pPalette')
            .accentPalette('v4pPalette')
        let baseUrl = window.location.hostname;
        if (baseUrl.indexOf("vets4pets.com") !== -1 || baseUrl.indexOf("-prod") !== -1) {
            //This means we are on prod server
            Parse.serverURL = 'https://app-prod.prod.v4papp.aws.petsathome.co.uk/parse/'
        } else if (baseUrl.indexOf("nonprod") !== -1) {
            Parse.serverURL = 'https://app-staging.nonprod.v4papp.aws.petsathome.co.uk/parse/'
        } else {
            Parse.serverURL = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/parse/';
        }
    }])
    .config(['$locationProvider', function ($locationProvider) {
        $locationProvider.hashPrefix('');
    }])
    .config(["$compileProvider", function ($compileProvider) {
        $compileProvider.imgSrcSanitizationWhitelist(/^\s*(local|http|https|app|tel|ftp|file|blob|content|ms-appx|x-wmapp0|cdvfile):|data:image\//);
    }])
    .config(["$mdDateLocaleProvider", function ($mdDateLocaleProvider) {
        $mdDateLocaleProvider.formatDate = function (date) {
            if (!date) {
                return null;
            }
            return moment((date.getMonth() + 1) + "/" + (date.getDate()) + "/" + date.getFullYear()).tz(moment.tz.guess()).format('DD/MM/YYYY');
        };
        $mdDateLocaleProvider.parseDate = function (dateString) {
            const m = moment.utc(dateString, ['DD/MM/YYYY', 'D/M/YYYY'], true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    }])
    .value('googleChartApiConfig', {
        version: '1.1',
        optionalSettings: {
            packages: ['corechart'],
            language: 'en'
        }
    });
app.directive('confirmPassword', ConfirmPassword);

function ConfirmPassword() {

    const linkFn = function (scope, element, attributes, ngModel) {
        ngModel.$validators.confirmPassword = function (modelValue) {
            return modelValue === scope.password;
        };

        scope.$watch("password", function () {
            ngModel.$validate();
        });
    };

    return {
        require: "ngModel",
        scope: {
            password: "=confirmPassword"
        },
        link: linkFn
    };
}

app.directive('backImg', function () {
    return function (scope, element, attrs) {
        attrs.$observe('backImg', function (value) {
            const subbedUrl = value.replace("http://", "https://s3.amazonaws.com/");
            element.css({
                //'background-image': 'linear-gradient(rgba(255, 255, 255, 0.5),rgba(255, 255,255, 0.5)), url(' + value + ')',
                'background-image': 'url(' + subbedUrl + ')',
                'background-size': 'cover',
                'background-position': 'center',
            });
        });
    };
});
app.controller('TransferFormController', ["$location", "$state", "$mdDialog", "$stateParams", "$q", "SessionService", function ($location, $state, $mdDialog, $stateParams, $q, SessionService) {
        ClientAgreementDialogController.$inject = ["$mdDialog"];
        const vm = this;
    vm.closingClinics = SessionService.data.closingClinics;
    vm.transfer = {};
    vm.loading = false;
    vm.transfer.postcodeRadius = "25";
    vm.mobileRegex = SessionService.mobileRegex;
    vm.emailRegex = SessionService.emailRegex;
    vm.alphanumericRegex = SessionService.alphanumericRegex;
    // vm.currentLocation = SessionService.getCurrentPosition().then(location => {
    //     vm.hasLocation = true;
    //     vm.geoLocation = location;
    // }, () => {
    //     vm.hasLocation = false;
    // });
    vm.resetForm = function () {
        vm.transfer = {};
        vm.loading = false;
        vm.verificationError = false;
        vm.moveConsentGiven = false;
        vm.leaveConsentGiven = false;
        vm.findError = false;
        vm.error = null;
    };
    // const testSettings = function () {
    //     SessionService.findClinicsByPostcode({postcode: "wd3 6ar"}).then(clinics => {
    //         vm.transfer.optionSelected = true;
    //         vm.clinicList = clinics;
    //         vm.loading = false;
    //     }, error => {
    //         vm.loading = false;
    //         vm.error = error.msg;
    //     });
    //     vm.transfer.verified = true;
    //     vm.transfer.postcode = "wd3 6ar";
    //     vm.transfer.transferEntry = "1";
    //     vm.transfer.optionSelected = true;
    //     vm.transfer.option = "leave";
    // };
    // testSettings();
        if (SessionService.data.error) {
            vm.loading = false;
            vm.error = {message: SessionService.data.error};
        }
        if ($stateParams.stateError) {
            vm.loading = false;
            vm.error = {message: "Unable to load VetBooker. Please try again later. We apologise for the inconvenience"};
        }
        if ($stateParams.clinicCode) {
            vm.transfer.clinicCode = $stateParams.clinicCode;
        }
        if ($stateParams.registration != null) {
            vm.selection = 'register';
        }
        vm.embedded = $stateParams.embedded;
        vm.visibleBox = "login-box";
        vm.verifyPassword = null;
    vm.resendCode = function () {
        vm.codeLoading = true;
        vm.error = null;
        SessionService.resendCode(vm.transfer.client.transferEntry).then(() => {
            vm.codeLoading = false;
            vm.resendCodeDone = true;
            }, () => {
            vm.resendCodeDone = true;
            vm.codeLoading = false;
                vm.error = "Unable to resend SMS code, please contact the clinic";
            });
        };
        vm.showAgreement = function () {
            $mdDialog.show({
                controller: ClientAgreementDialogController,
                controllerAs: 'dialogCtrl',
                templateUrl: vm.isGroomRoom ? 'main/pets-client-agreement.html' : 'main/client-agreement.html'
            }).then(function () {
            }, function (error) {
            });
        };

        vm.resetError = function () {
            vm.error = {};
        };
    vm.getClientNumber = function () {
            const deferred = $q.defer();
            vm.loading = true;
        vm.findError = false;
        SessionService.getClientNumber(vm.transfer).then(client => {
            vm.loading = false;
            vm.transfer.client = client;
            deferred.resolve();
        }, () => {
            vm.findError = true;
            vm.loading = false;
            deferred.reject();
        });
            return deferred.promise;
        };
    vm.verifyContact = function () {
            const deferred = $q.defer();
            vm.loading = true;
        vm.verificationError = false;
        SessionService.verifyContact(vm.transfer.transferEntry, vm.transfer.verification).then(() => {
                vm.loading = false;
            vm.transfer.verified = true;
                deferred.resolve();
        }, () => {
            vm.verificationError = true;
                vm.loading = false;
                deferred.reject();
            });
            return deferred.promise;
        };
    vm.finishWizard = function () {
        const deferred = $q.defer();
        vm.loading = true;
        vm.error = null;
        const transferPackage = {
            transferId: vm.transfer.transferEntry,
            option: vm.transfer.option,
            newClinicEmail: vm.transfer.newClinicEmail,
            newClientId: vm.transfer.newClientId,
        };
        if (vm.transfer.selectedClinic) {
            transferPackage.newClinicId = vm.transfer.selectedClinic.objectId
        }
        SessionService.finishWizard(transferPackage).then(() => {
            vm.loading = false;
            vm.wizardFinished = true;
            deferred.resolve("Done");
        }, error => {
            vm.error = error.msg;
            vm.loading = false;
            deferred.reject(error);
        });
        return deferred.promise;
    };

    vm.selectOption = function () {
        const deferred = $q.defer();
        vm.loading = true;
        vm.error = null;
        if (vm.transfer.option === 'move') {
            vm.clinicsLoading = true;
            SessionService.findClinicsByPostcode({
                postcode: vm.transfer.postcode,
                radius: vm.transfer.postcodeRadius
            }).then(clinics => {
                vm.transfer.optionSelected = true;
                vm.clinicList = clinics;
                vm.clinicsLoading = false;
                vm.loading = false;
            }, error => {
                vm.loading = false;
                vm.clinicsLoading = false;
                vm.error = error.msg;
            });
        } else if (vm.transfer.option === 'leave') {
            vm.transfer.optionSelected = true;
            vm.loading = false;
        }
        return deferred.promise;
    };
    vm.findByPostcode = function () {
        const deferred = $q.defer();
        vm.clinicsLoading = true;
        vm.error = null;
        SessionService.findClinicsByPostcode({
            postcode: vm.transfer.postcode,
            radius: vm.transfer.postcodeRadius
        }).then(clinics => {
            vm.clinicList = clinics;
            vm.clinicsLoading = false;
        }, error => {
            vm.clinicsLoading = false;
            vm.error = error.msg;
        });
        return deferred.promise;
    };
    vm.selectClinic = function (clinic) {
        vm.transfer.selectedClinic = clinic;
    };

    function ClientAgreementDialogController($mdDialog) {
            const vm = this;
            vm.hide = function () {
                $mdDialog.hide();
            };
            vm.cancel = function () {
                $mdDialog.cancel();
            };
        }

    }]
);
const titles = ["Mr", "Mrs", "Miss", "Ms", "Mr & Mrs", "Dr", "Lord", "Lady"];
const phoneTypes = [{name: "Phone", typeCode: 0}, {name: "Mobile", typeCode: 3}];
const sexes = ["Male", "Female", "Unknown"];
const emailRegex = '(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])';

app.factory('SessionService', ["$q", "$window", function ($q, $window) {
    'use strict';
    let data = {};
    data.sexes = sexes;
    data.error = null;
    data.titles = titles;
    const service = this;
    data.loading = false;
    data.navbarLoaded = false;

    return {
        emailRegex: emailRegex,
        mobileRegex: '(\\+44\\s?7\\d{3}|\\(?07\\d{3}\\)?)\\s?\\d{3}\\s?\\d{3}$',
        phoneTypes: phoneTypes,
        alphanumericRegex: "^[A-Za-z0-9 _\-]*[A-Za-z0-9\-][A-Za-z0-9 _\-]*$",

        getClientNumber: function (transferClient) {
            const deferred = $q.defer();
            Parse.Cloud.run("findClientForTransfer", transferClient
                , {}).then(result => {
                if (result.transferEntry) {
                    transferClient.transferEntry = result.transferEntry;
                    deferred.resolve(transferClient);
                } else if (result.errorCode) {
                    transferClient.errorCode = result.errorCode;
                    transferClient.message = {msg: result.errorMessage};
                    transferClient.clinic = result.clinic;
                    deferred.reject(transferClient);
                } else if (result.code && result.code === 204) {
                    transferClient.errorCode = 204;
                    transferClient.message = {msg: "Sorry, we’ve been unable to match your details to a customer record. Please check your details are correct and try again."};
                    deferred.reject(transferClient);
                }
            }, error => deferred.reject(error));
            return deferred.promise;
        },
        resendCode: function (transferId) {
            const deferred = $q.defer();
            Parse.Cloud.run("resendTransferCode", {transferId: transferId}
                , {}).then(() => deferred.resolve(), error => deferred.reject(error));
            return deferred.promise;
        },
        verifyContact: function (transferId, verificationCode) {
            const deferred = $q.defer();
            Parse.Cloud.run("verifyContactForTransfer", {
                    transferId: transferId,
                    verificationCode: verificationCode.toString()
                }
                , {}).then(function (result) {
                if (result.verified) {
                    deferred.resolve();
                } else {
                    deferred.reject("Unverified");
                }
            }, error => deferred.reject(error));
            return deferred.promise;
        },
        registerNavController: function (controller) {
            service.navController = controller;
        },
        getNavController: function () {
            return service.navController;
        },
        getClinicDetails: function (clinicCode) {
            const deferred = $q.defer();
            Parse.Cloud.run("getClinicDetails", {
                'clinicCode': clinicCode
            }, {}).then(result => {
                if (service && service.navController) {
                    data.isGroomRoom = result.groomRoom;
                    data.clinicDetails = result;
                    service.navController.setPreload(false);
                }
                deferred.resolve(result)
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        },
        // getCurrentPosition: function () {
        //     const deferred = $q.defer();
        //     if (!$window.navigator.geolocation) {
        //         deferred.reject('Geolocation not supported.');
        //     } else {
        //         $window.navigator.geolocation.getCurrentPosition(
        //             function (position) {
        //                 deferred.resolve(position);
        //             },
        //             function (err) {
        //                 deferred.reject(err);
        //             });
        //     }
        //     return deferred.promise;
        // },
        findClinicsByPostcode: function (params) {
            const deferred = $q.defer();
            Parse.Cloud.run("getTransferClinicsByPostcode", params, {}).then(result => {
                data.clinicsList = result;
                deferred.resolve(result)
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        },
        getClosingClinicList: function () {
            const deferred = $q.defer();
            Parse.Cloud.run("getTransferClinicList", {}, {}).then(result => {
                data.closingClinics = result;
                deferred.resolve(result)
            }, function (error) {
                void 0;
                this.error = error;
                deferred.resolve(result)
            });
            return deferred.promise;
        },
        finishWizard: function (transferDetails) {
            const deferred = $q.defer();
            Parse.Cloud.run("finishV4PTransfer", transferDetails, {}).then(() => {
                deferred.resolve("done");
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        },
        data: data
    }
}]);

app.config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    $stateProvider
    //Login Modules
        .state('landing', {
            url: '/landing?clinicCode',
            params: {clinicCode: {dynamic: true}},
            templateUrl: 'landing.html',
            controller: 'TransferFormController',
            resolve: {
                login: ["SessionService", function (SessionService) {
                    return SessionService.getClosingClinicList();
                }]
            }
        });
    $urlRouterProvider.otherwise('/landing');
}]);